import { ISuccessTicketStatusOld } from '../../../../../../../../types';
import { ReactComponent as IconSuccess } from '../../../../../../../../assets/images/icons/ic_check_circle.svg';
import { getUITime } from '../../utils/getUITime';
import './styles.sass';

interface ITicketSuccessStatusOldProps {
    successData: ISuccessTicketStatusOld;
    onClose: () => void;
}

export const TicketSuccessStatusOld = ({ successData, onClose }: ITicketSuccessStatusOldProps) => {
    return (
        <div className="ticket-status-success-old">
            <div className="ticket-status-success-old__icon">
                <IconSuccess />
            </div>
            <div className="ticket-status-success-old__info">
                <div className="ticket-status-success-old__info-type">{successData?.tariffName}</div>
                <div className="ticket-status-success-old__info-description">
                    {successData?.activeSinceTime && (
                        <span className="ticket-status-success-old__info-description-time">
                            {getUITime(successData.activeSinceTime, successData?.activeUntilTime)}
                        </span>
                    )}
                    <span
                        title={successData.productName}
                        className="ticket-status-success-old__info-description-product-name"
                    >
                        {successData.productName}
                    </span>
                </div>
            </div>
            <div className="ticket-status-success-old__btn-wrap">
                <button onClick={onClose} type="button" className="ticket-status-success-old__btn">
                    ОК
                </button>
            </div>
        </div>
    );
};
